<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<p class="BRK4_Page_break"><span aria-label="ix" id="pg_ix" role="doc-pagebreak"></span></p>
<header>
<p class="SP" id="ack"> </p>
<h1 class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><i>Acknowledgments</i></span></h1>
</header>
<p class="FMCO1">I’d like to thank my British editors, Jade Chandler and Maddie West, who helped get this book as good as it could be, as well as the incomparable Sarah Crichton for her brilliance and unflagging support as my editor in the United States, and their respective teams in rights, sales, and marketing for their tireless efforts getting the books into the hands of readers on both sides of the Atlantic, which is after all what it is all about. I would also like to thank my thoughtful, long-suffering, clever agent, Victoria Hobbs, for ten years of keeping me on the right track, and my husband for doing everything else.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?46228862